import { defineComponent as _defineComponent } from 'vue';
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass } from "vue";
const _hoisted_1 = { class: "addressLookup" };
const _hoisted_2 = {
    key: 1,
    class: "addressResults"
};
const _hoisted_3 = { class: "addressResultsHeader" };
const _hoisted_4 = { class: "addressResultsCount" };
const _hoisted_5 = {
    key: 0,
    class: "addressResultsPostcode"
};
const _hoisted_6 = { class: "addressList" };
const _hoisted_7 = ["onClick"];
const _hoisted_8 = { class: "addressRowLine1" };
const _hoisted_9 = { class: "addressRowMeta" };
import { ref, computed, watch, onMounted } from 'vue';
import { useCustomer } from '@/composables/useCustomer';
export default /*@__PURE__*/ _defineComponent({
    __name: 'AddressLookup',
    props: {
        value: {},
        theme: {},
        showNumber: { type: Boolean }
    },
    emits: ["update:modelValue"],
    setup(__props, { emit: __emit }) {
        const props = __props;
        const emit = __emit;
        const { lookupAddress: customerLookupAddress } = useCustomer();
        const postCode = ref('');
        const number = ref(null);
        const pageTheme = ref(props.theme || 'dark');
        const results = ref(null);
        const address = ref(null);
        const searching = ref(false);
        const modelValue = computed({
            get() {
                return address.value;
            },
            set(value) {
                address.value = value;
                emit('update:modelValue', address.value);
            }
        });
        function onLoad() {
            if (props.value) {
                postCode.value = props.value.postCode;
                lookupAddress();
                watch(results, (newVal) => {
                    if (newVal) {
                        if (props.value && props.value.line1) {
                            const foundAddress = results.value.find(a => a.line1 === props.value.line1);
                            if (foundAddress) {
                                modelValue.value = foundAddress;
                            }
                            else {
                                modelValue.value = null;
                            }
                        }
                    }
                });
            }
        }
        function lookupAddress() {
            if (!postCode.value || postCode.value.length < 4) {
                return;
            }
            searching.value = true;
            customerLookupAddress(postCode.value, number.value ?? '', (res) => {
                searching.value = false;
                results.value = res.addresses;
            });
        }
        onMounted(() => { onLoad(); });
        return (_ctx, _cache) => {
            const _component_v_text_field = _resolveComponent("v-text-field");
            const _component_v_col = _resolveComponent("v-col");
            const _component_v_row = _resolveComponent("v-row");
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                (!results.value)
                    ? (_openBlock(), _createBlock(_component_v_row, { key: 0 }, {
                        default: _withCtx(() => [
                            _createVNode(_component_v_col, null, {
                                default: _withCtx(() => [
                                    _createVNode(_component_v_text_field, {
                                        modelValue: postCode.value,
                                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((postCode).value = $event)),
                                        type: "text",
                                        label: searching.value ? 'Searching....' : 'Enter postcode',
                                        variant: "solo",
                                        flat: true,
                                        "sin--gle-line": "",
                                        "bg-color": pageTheme.value == 'dark' ? '#ffffffaa' : '#3328470D',
                                        "append-inner-icon": postCode.value && postCode.value.replace(/\s/g, '').length >= 4 ? 'mdi-magnify' : '',
                                        "onClick:appendInner": lookupAddress
                                    }, null, 8, ["modelValue", "label", "bg-color", "append-inner-icon"])
                                ]),
                                _: 1
                            })
                        ]),
                        _: 1
                    }))
                    : _createCommentVNode("", true),
                (results.value)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                        _createElementVNode("div", _hoisted_3, [
                            _createElementVNode("span", _hoisted_4, [
                                _createElementVNode("span", null, _toDisplayString(results.value.length) + _toDisplayString(results.value.length === 1 ? ' address' : ' addresses') + " found", 1),
                                (postCode.value)
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString(postCode.value.toUpperCase()), 1))
                                    : _createCommentVNode("", true)
                            ]),
                            _createElementVNode("span", {
                                class: "addressResultsChange",
                                onClick: _cache[1] || (_cache[1] = ($event) => (results.value = null))
                            }, "Change postcode")
                        ]),
                        _createElementVNode("div", _hoisted_6, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(results.value, (m, i) => {
                                return (_openBlock(), _createElementBlock("div", {
                                    key: i,
                                    class: _normalizeClass(["addressRow", { selected: address.value === m }]),
                                    onClick: ($event) => (modelValue.value = m)
                                }, [
                                    _createElementVNode("span", _hoisted_8, _toDisplayString(m.line1), 1),
                                    _createElementVNode("span", _hoisted_9, _toDisplayString([m.line2, m.town, m.postCode].filter(Boolean).join(', ')), 1)
                                ], 10, _hoisted_7));
                            }), 128))
                        ])
                    ]))
                    : _createCommentVNode("", true)
            ]));
        };
    }
});
